<template>
  <div class="NewsCenterDetails" style="align-self: center;">
     <!-- 标题 -->
      <div class="flex-all-center mt-76">
        <p class="titletext">
          {{ $t('newsCenterDetails1.text1') }}<br>
          {{ $t('newsCenterDetails1.text2') }}
        </p>
      </div>
    <!-- 标题下图标 --> 
    <div class="timeandaddress flex-all-center">
        <div class="mr-6"><img src="../../assets/images/time_icon.png" class="iconimg "></div>
        <div class="mr-38">{{ $t('newsCenterDetails1.text3') }}</div>
        <div class="mr-6"><img src="../../assets/images/postion_icon.png" class="iconimg"></div>
        <div>{{ $t('newsCenterDetails1.text4') }}</div>
    </div>
    <!-- 正文 -->
     <div class="main">
      <div class="maintext">

        <p>{{ $t('newsCenterDetails1.text5') }}</p>
        
        <p class="mt-20">{{ $t('newsCenterDetails1.text6') }}</p>

        <div class="flex-all-center">
          <img class="picimg" src="../../assets/images/NewsCenterDetails_pic1.png" >
        </div>
        
        <p>{{ $t('newsCenterDetails1.text7') }}</p>
        <div class="flex-all-center">
          <img class="picimg" src="../../assets/images/NewsCenterDetails_pic2.png" >
        </div>
        
        <p>{{ $t('newsCenterDetails1.text8') }}</p>
        <div class="flex-all-center">
          <img class="picimg" src="../../assets/images/NewsCenterDetails_pic3.png" >
        </div>
        
        <p>{{ $t('newsCenterDetails1.text9') }}</p>
      </div>
     </div>
    <div class="footer"></div>
</div>
</template>

<script>
export default {
  name: "NewsCenterDetails1",
  components: {
    // Tabbar,
  },
  data() {
    return {
    };
  },
  computed: {},
  created() {},
  methods: {},

};
</script>

<style lang="scss" scoped>
.NewsCenterDetails
{
    color: #000;
    width: 100%;
}

.titletext
{
  font-family: "OPPO-B";
  max-width: 990px;
  line-height: 60px;
  font-size: 42px;
  text-align: center;
}

.main
{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
}

.maintext
{
   text-indent: 32px;
   text-align:justify;
   max-width: 990px;
   width: 100%;
   line-height: 32px;

   p{
    font-family:"OPPO-R";
    font-size: 16px;
    
   }
   .maintitie
   {
    text-align: center;
    font-family: "OPPO-B";
    font-size: 28px;
    margin-top: 40px;
   }
}

.timeandaddress
{
    color: #909399;
    margin-top: 37px;
    font-family: "OPPO-R";
    font-size: 16px;
}

.iconimg
{
    width: 17px;
    height: auto;
    position:relative;
    top: 2px;
}


.picimg
{
    width: 90%;
    height: auto;
    margin-top: 40px;
    margin-bottom: 40px;
}

.footer
{
  margin-top: 120px;
}

@media (max-width: 768px) {
.titletext
{
  width: 90%;
}
.main
{
  display: flex;
  flex-wrap: wrap;
}

.maintext
{
   text-indent: 32px;
   font-family: "OPPO-R";
   font-size: 17px;
   line-height: 32px;
   width: 90%;

   p{
    font-family:"OPPO-R";
    font-size: 16px;
    
   }
   .maintitie
   {
    text-align: center;
    font-family: "OPPO-B";
    font-size: 28px;
    margin-top: 40px;
   }
}

.picimg
{
    width: 90%;
    height: auto;
    margin-top: 29px;
    margin-bottom: 29px;
}

.footer
{
  margin-top: 40px;
}
}
</style>